import React from 'react';  
import './index.css';
import ImgCard from 'component/imgCard'

class InfoImg extends React.Component{
  render(){
    const {thumb} = this.props;

    return (
      <div className="info-img">
        <ImgCard src={thumb?thumb:''} />
      </div>
      )
  }
}
export default InfoImg;